import { render, staticRenderFns } from "./ListPerguntas.vue?vue&type=template&id=409d1148&"
import script from "./ListPerguntas.vue?vue&type=script&lang=js&"
export * from "./ListPerguntas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports